import { useCallback, useRef } from 'react';
import { useApi } from '../../hooks/useApi';
import { describeRequest } from './request';

// The V3 pages' way to call the API: the existing client (so sign-in, token refresh and cookies are reused), with the call described by
// describeRequest. Each answers the response body. useApi returns a new object on every render, so the latest one is kept in a ref and
// the functions stay the same (a page can list them in an effect's dependencies).
export function useV3Api() {
  const api = useApi();
  const latest = useRef(api);
  latest.current = api;

  const get = useCallback(async (route, params) => {
    const call = describeRequest(route, params);
    const response = await latest.current.request('GET', call.path);
    return response.data;
  }, []);

  const put = useCallback(async (route, body, params) => {
    const call = describeRequest(route, params, 'PUT', body);
    const response = await latest.current.request('PUT', call.path, body);
    return response.data;
  }, []);

  const post = useCallback(async (route, params) => {
    const call = describeRequest(route, params, 'POST');
    const response = await latest.current.request('POST', call.path, null);
    return response.data;
  }, []);

  const del = useCallback(async (route, params) => {
    const call = describeRequest(route, params, 'DELETE');
    const response = await latest.current.request('DELETE', call.path, null);
    return response.data;
  }, []);

  return { get, put, post, del };
}
